module.exports = __webpack_public_path__ + "img/5.1886090.webp";